import React from "react";
import { useDesign } from "../../context/contextDesign";
import { useAwsConfig } from "../../context/Dashboard/aws/contextConfig";
import { useThemeMode } from "../../context/contextTheme";
import Guide from "../../assets/vid/cloud/aws-guide.webm";
import ScanView from "./misconfig/ScanView";
import LoadBtn from "./loadBtn";

const AwsConfigView = () => {
  const { zoom, FadingComponent, toggleUpgradeCard } = useDesign();
  const { theme } = useThemeMode();

  const {
    handleConfigScan,
    configAssets,
    configScanLoading,
    accessKey,
    setAccessKey,
    secretKey,
    setSecretKey,
    error,
  } = useAwsConfig();

  // ✅ DERIVED STATE (single source of truth)
  const hasConfigData =
    Array.isArray(configAssets) && configAssets.length > 0;

  return (
    <div style={{ zoom }}>
      {!hasConfigData ? (
        <div className="d-flex flex-column py-4 col-lg-6 col-md-6 col-sm-12 col-12">
          <form onSubmit={handleConfigScan}>
            {/* Access Key */}
            <div className="mb-3">
              <div className="input-group">
                <span
                  className="input-group-text fw-bold"
                  style={{
                    color: theme.textColorInv,
                    background: theme.textColor,
                    width: 120,
                  }}
                >
                  Access Key:
                </span>
                <input
                  className="form-control"
                  type="text"
                  value={accessKey}
                  onChange={(e) => setAccessKey(e.target.value)}
                  placeholder="Example: AKIAIOSFODNN7EXAMPLE"
                  required
                  disabled={configScanLoading}
                />
              </div>
            </div>

            <div className="mb-3">
              <div className="input-group">
                <span
                  className="input-group-text fw-bold"
                  style={{
                    color: theme.textColorInv,
                    background: theme.textColor,
                    width: 120,
                  }}
                >
                  Secret Key:
                </span>
                <input
                  className="form-control"
                  type="text"
                  value={secretKey}
                  onChange={(e) => setSecretKey(e.target.value)}
                  placeholder="Example: wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY"
                  required
                  disabled={configScanLoading}
                />
              </div>
            </div>

            {error && (
              <div
                className="error-hover text-danger fw-semibold mb-2"
                onClick={error.card ? toggleUpgradeCard : undefined}
                style={{ cursor: error.card ? "pointer" : "default" }}
              >
                {error.message}
              </div>
            )}

            {/* Info */}
            <div className="text-muted small">
              <strong>Note:</strong> This misconfiguration scan may take time
              depending on your AWS environment. Please keep your credentials
              valid during the scan.
            </div>

            {/* Submit */}
            <div className="d-flex justify-content-end py-4">
              <button
                type="submit"
                disabled={configScanLoading || !accessKey || !secretKey}
                className="btn rounded-3 fw-medium fs-5 d-flex justify-content-center align-items-center"
                style={{
                  color: theme.textColorInv,
                  background:
                    configScanLoading || !accessKey || !secretKey
                      ? theme.textMuted
                      : theme.textColor,
                  width: 240,
                  height: 50,
                  opacity:
                    configScanLoading || !accessKey || !secretKey ? 0.7 : 1,
                  cursor:
                    configScanLoading || !accessKey || !secretKey
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                {configScanLoading ? <LoadBtn /> : "Start Scan"}
              </button>
            </div>
          </form>

          <hr className="text-secondary" />

          {/* Guide */}
          <FadingComponent>
            <div style={{ color: theme.textColor }}>
              <div className="fw-bold fs-5 mb-3">
                Steps to get Access Key & Secret Key
              </div>
              <video
                className="w-100 rounded-4 border shadow-sm"
                src={Guide}
                controls
                autoPlay
                muted
              />
            </div>
          </FadingComponent>
        </div>
      ) : (
        <ScanView />
      )}
    </div>
  );
};

export default AwsConfigView;
